import { Box, Typography, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";

function WrapperAverageSell({ data }) {
  return (
    <BoxWrapper>
      <Box display="flex" marginBottom={2}>
        <Typography
          variant="h6"
          component="span"
          color="error.main"
          fontWeight={600}
        >
          <NumberFormats value={data?.sellFilled} />
        </Typography>

        <Typography
          variant="h6"
          component="span"
          color="error.main"
          marginLeft={1}
        >
          {data?.name}
        </Typography>
      </Box>

      <BoxStyle>
        <Box>
          <Typography
            variant="h6"
            component="span"
            color="text.main"
            fontWeight={600}
            marginLeft={1}
          >
            <NumberFormats value={data?.sellAvgUSDT} />
          </Typography>
          <Typography variant="h6" component="span" marginLeft={1}>
            USDT
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="h6"
            component="span"
            color="text.main"
            fontWeight={600}
            marginLeft={1}
          >
            <NumberFormats value={data?.sellAvgToman} />
          </Typography>
          <Typography variant="h6" component="span" marginLeft={1}>
            TOMAN
          </Typography>
        </Box>
      </BoxStyle>
    </BoxWrapper>
  );
}
const BoxStyle = styled(Box)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.error.main}`,
}));

const BoxWrapper = styled(Box)(() => ({
  cursor: "pointer",
}));
export default WrapperAverageSell;
